// extracted by mini-css-extract-plugin
export default {"wrapper":"DrawMode__wrapper___2Og1w","col":"DrawMode__col___2k0Ah"};